import { apiClient, apiConfig } from '@/lib/api/client-api';

export class BaseApiService {
  protected apiClient = apiClient;
  protected apiConfig = apiConfig;
}
